<template>
  <div>
    <ejs-dialog
      ref="baseDialog"
      :class="{'baseDialog': true, 'resizeDialog': enableResize}"
      :animation-settings="animationSettings"
      :before-open="setSelectedCampaign"
      :close="closeDialog"
      :close-on-escape="true"
      :content="contentTemplate"
      :header="isIframe || forceHeader ? headerTemplate : null"
      :height="height"
      :is-modal="true"
      :overlay-click="closeDialog"
      :show-close-icon="isIframe || showCloseIcon"
      :visible="false"
      :width="width"
      :enable-resize="enableResize"
      :resize-handles="resizeHandles"
    />
  </div>
</template>
<script>
import Vue from 'vue'
import { DialogPlugin } from '@syncfusion/ej2-vue-popups'
import { iframeParentCommunication } from '@/mixins/iframeParentCommunication'

Vue.use(DialogPlugin)

const headerTemplateVue = Vue.component('HeaderTemplate', {
  data () {
    return {
      data: {}
    }
  },
  template: '<span>{{$parent.$parent.title}}</span>'
})

const contentTemplateVue = Vue.component('ContentTemplate', {
  data () {
    return {
      test: {},
      dialogStyle: {
        textAlign: 'center',
        padding: '20px 0'
      }
    }
  },
  methods: {
    cancel () {
      this.$parent.$parent.closeDialog()
    },
    submit () {
      this.$parent.$parent.submit()
      this.$parent.$parent.closeDialog()
    }
  },
  template: `
    <div v-if="$parent.$parent.data">
      <div class="dialogContent" v-bind:style="dialogStyle"> 
        <h2 v-if="!$parent.$parent.isIframe">{{$parent.$parent.title}}</br></h2>
        <p v-html="$parent.$parent.content" /></br>
        <div v-if="!$parent.$parent.isIframe">
          <button id="dialogBtnCancel" class="btn btn-lg btn-outline-secondary" @click="cancel" tabindex="-1">{{$parent.$parent.cancelButton.label}}</button>
          <button id="dialogBtnSubmit" v-bind:class="['btn btn-lg', $parent.$parent.submitButton.class ? $parent.$parent.submitButton.class : 'btn-danger']" @click="submit" tabindex="-1">{{$parent.$parent.submitButton.label}}</button>
        </div>
      </div>
    </div>`
})

export default {
  name: 'BaseDialog',
  mixins: [iframeParentCommunication],
  props: {
    title: {
      type: String,
      default: 'Confirm'
    },
    content: String,
    cancelButton: {
      type: Object,
      default: function () {
        return {
          label: 'Cancel',
          action: () => {}
        }
      }
    },
    submitButton: {
      type: Object,
      default: function () {
        return {
          label: 'Ok',
          class: 'btn-danger',
          action: () => {}
        }
      }
    },
    isIframe: {
      type: Boolean,
      default: false
    },
    showCloseIcon: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '400px'
    },
    height: String,
    forceHeader: {
      type: Boolean,
      default: false
    },
    customHeaderTemplate: [Object, Function],
    customContentTemplate: [Object, Function],
    onOpen: Function,
    onClose: Function,
    enableResize: {
      type: Boolean,
      required: false,
      default: false
    },
    resizeHandles: {
      type: Array,
      required: false,
      default: function () {
        return ['All']
      }
    }
  },
  data () {
    return {
      data: {},
      animationSettings: { effect: 'Fade', duration: 100 },
      headerTemplate () {
        return ['function', 'object'].includes(typeof this.customHeaderTemplate) ? { template: this.customHeaderTemplate } : { template: headerTemplateVue }
      },
      contentTemplate: () => {
        return ['function', 'object'].includes(typeof this.customContentTemplate) ? { template: this.customContentTemplate } : { template: contentTemplateVue }
      }
    }
  },
  methods: {
    setSelectedCampaign () {
      this.data = this.$store.getters.getGridSelectedTemplate
    },
    openDialog () {
      this.$refs.baseDialog.show()
      const data = { action: 'eIn_iframe_height_change', value: 0 }
      this.SendMessageToParent(data)
      if (this.onOpen) {
        this.onOpen()
      }
    },
    closeDialog () {
      this.cancelButton.action()
      this.$refs.baseDialog.hide()
      const data = { action: 'eIn_iframe_height_change', value: document.body.clientHeight }
      this.SendMessageToParent(data)
      if (this.onClose) {
        this.onClose()
      }
    },
    submit () {
      this.submitButton.action()
    }
  }
}
</script>
<style lang="scss" scoped>
  .baseDialog {
    max-height: unset !important;
  }
</style>
